import { Component, Vue } from 'vue-property-decorator'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import OtherUrlConstants from '@/common/OtherUrlConstants'

@Component({
  name: 'CAHG1130',
  components: {}
  })
export default class CAHG1130Controller extends Vue {
  private OtherUrlConstants = OtherUrlConstants
  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContentNoLogin()
  }

  /**
   * 初期処理
   */
  private async init() {}

  /**
   * シミュレーションのご利用にあたってリンク押下
   */
  private gotoCAHG1140() {
    this.$router.push({ name: 'cahg1140BeforeLogin' })
  }

  /**
   * NTTデータ・エービック社の外部シミュレーション（外部サイト）画面に遷移する。
   * iDeCoに加入すると？リンク押下
   * 選択制DCの税制メリットは？リンク押下
   * マッチング拠出を利用すると？リンク押下
   * ライフプランシミュレーションリンク押下
   * お金の統計情報リンク押下
   */
  private gotoExternalSimulation(url: string) {
    window.open(url, '_blank')
  }

  /**
   * ねんきん受取額シミュレーションリンク押下
   */
  private gotoCAHG1220() {
    this.$router.push({ name: 'cahg1220BeforLogin' })
  }

  /**
   * 将来受取額シミュレーションリンク押下
   */
  private gotoCAHG1230() {
    this.$router.push({ name: 'cahg1230BeforeLogin' })
  }

  /**
   * ログインに戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
